import QuotaManagementListing from "../../Components/Charging/QuotaManagement";


export default function QuotaManagementLists(){
    return(
        <QuotaManagementListing />
    )
}